import React, { useState, useRef, useCallback } from 'react';

const MenuLateralLeft = ({showListAvailable,paginas,returnListInitial,addToMenuFromAvailable,addToListValuesFromAvailable,getIconComponent}) => {
  const [showModal, setShowModal] = useState(false);
  const [customLink, setCustomLink] = useState({ text: '', url: 'https://', target: '_self' });
  const [notification, setNotification] = useState(null);
  const [itemCount, setItemCount] = useState(0);
    const [availableItems] = useState([
    { id: 'page-home', title: 'Inicio', type: 'page', icon: 'file', url: '/' },
    { id: 'page', title: 'Paginas', type: 'page', icon: 'file', url: '#' },
    { id: 'catogory', title: 'Categorias', type: 'category', icon: 'folder', url: '#' },
    { id: 'products', title: 'Productos', type: 'Productos', icon: 'folder', url: '#' },
    { id: 'transversal', title: 'Transversales', type: 'transversal', icon: 'folder', url: '#' },
    { id: 'custom-link', title: 'Enlace externo', type: 'custom', icon: 'link', url: '#' }
  ]);

  const getTypeLabel = (type) => {
    const labels = {
      'page': 'PÁGINA',
      'category': 'CATEGORÍA',
      'custom': 'PERSONALIZADO'
    };
    return labels[type] || type?.toUpperCase() || 'ITEM';
  };

  console.log("menulateralleft")

return (
          <div className="wp-panel">
            <div className="wp-panel-header">
              <span>Opciones Disponibles</span>
              {
                showListAvailable !== "" ?
                <button onClick={() => returnListInitial()} className="btnReturn">{"<"}</button>
                :
                null
              }
              
            </div>
            <div className="wp-panel-content">
              {
                showListAvailable !== "" && paginas.hasOwnProperty(showListAvailable) ? 

                

                  showListAvailable === "category" ?
                  	
	                  window.Listcategory.map(item => (
	                      <div
	                        key={item.id}
	                        className="wp-available-item"
	                        onClick={() => addToMenuFromAvailable(item)}
	                      >
	                        <div className="available-item-header">
	                          {getIconComponent(item.icon)}
	                          <span>{item.title}</span>
	                          <span className="available-item-meta">
	                            {getTypeLabel(item.type)}
	                          </span>
	                        </div>
	                      </div>
	                    ))

	                  :
	                  showListAvailable === "transversal" ?

	                
		                  	window.Listtransversal.map(item => (
			                      <div
			                        key={item.id}
			                        className="wp-available-item"
			                        onClick={() => addToMenuFromAvailable(item)}
			                      >
			                        <div className="available-item-header">
			                          {getIconComponent(item.icon)}
			                          <span>{item.title}</span>
			                          <span className="available-item-meta">
			                            {getTypeLabel(item.type)}
			                          </span>
			                        </div>
			                      </div>
			                    ))
			            :

		                  	paginas["page"].map(item => (
			                      <div
			                        key={item.id}
			                        className="wp-available-item"
			                        onClick={() => addToMenuFromAvailable(item)}
			                      >
			                        <div className="available-item-header">
			                          {getIconComponent(item.icon)}
			                          <span>{item.title}</span>
			                          <span className="available-item-meta">
			                            {getTypeLabel(item.type)}
			                          </span>
			                        </div>
			                      </div>
			                    ))





                : 

                  availableItems.map(item => (
                      <div
                        key={item.id}
                        className="wp-available-item"
                        onClick={() => addToListValuesFromAvailable(item)}
                      >
                        <div className="available-item-header">
                          {getIconComponent(item.icon)}
                          <span>{item.title}</span>
                          <span className="available-item-meta">
                            {getTypeLabel(item.type)}
                          </span>
                        </div>
                      </div>
                    ))

              }
            </div>
            <div className="wp-panel-footer">
              <small>
                <strong>Click</strong> para añadir al menú
              </small>
            </div>
          </div>
  );
};

export default MenuLateralLeft;